import { supabase } from "@/integrations/supabase/client";

type FeatureFlagResponse = {
  enabled: boolean;
};

export async function getFeatureFlag(
  flagName: string
): Promise<FeatureFlagResponse> {
  const { data, error } = await supabase
    .from("feature_flags_public")
    .select("enabled_for_me")
    .eq("name", flagName)
    .maybeSingle();

  if (error) {
    console.error(`Error fetching feature flag ${flagName}:`, error);
    return { enabled: false };
  }

  return { enabled: data?.enabled_for_me ?? false };
}
